import { Space, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { CreateWorkItemForm } from '@/features/work/components/create-work-item-form/CreateWorkItemForm';
import { translate } from '@/shared/i18n/translate';
import { LBModalFullscreenLayout } from '@/shared/layouts';
import { LBButton, LBModalHeader } from '@/shared/ui-kit/components';

export const SendWorkInviteView = ({
  clubId,
  cause,
  artistId,
  revokeInvite,
  canSendInvite
}: {
  cause: 'incompleted' | 'artist-have-contract' | null;
  clubId: string;
  canSendInvite: boolean;
  artistId: string;
  revokeInvite: () => void;
}) => {
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      <LBModalFullscreenLayout opened={opened} onClose={close}>
        <LBModalHeader onClose={close} />
        <CreateWorkItemForm
          artistProfileId={+artistId}
          clubProfileId={+clubId}
          workItemType='invite'
          onCancel={close}
          onSubmittingSuccess={() => {
            close();
          }}
        />
      </LBModalFullscreenLayout>

      {canSendInvite && (
        <LBButton fullWidth disabled={!canSendInvite} onClick={open}>
          {translate('commons.invite')}
        </LBButton>
      )}

      {!canSendInvite && cause === 'incompleted' && (
        <>
          <Text>{translate('pages.workInteraction.club.incompleted')}</Text>
          <Space h={10} />
          <LBButton fullWidth disabled={!canSendInvite} onClick={open}>
            {translate('commons.invite')}
          </LBButton>
        </>
      )}
      {!canSendInvite && cause === 'artist-have-contract' && (
        <>
          <Text>
            {translate('pages.workInteraction.club.artistHaveContract')}
          </Text>
          <Space h={10} />
        </>
      )}

      {!canSendInvite && cause === null && (
        <LBButton fullWidth onClick={revokeInvite}>
          {translate('commons.cancelInvite')}
        </LBButton>
      )}
    </>
  );
};
